import { LOAD_EMPTY_CART } from '../actionTypes/CartActionTypes';

export default function LoadEmptyCartReducer(state = false, action) {
    // NOSONAR
    switch (
        action.type // NOSONAR
    ) {
        case LOAD_EMPTY_CART:
            return action.payload;
        default:
            return state;
    }
}
